import { useMemo } from "react";
import {
  InternalAdminUserAttributeListInput,
  InternalAdminUserAttributeListQuery,
  InternalAdminUserAttributeListQueryVariables,
} from "gql/graphql";
import { useQuery } from "@apollo/client";
import INTERNAL_ADMIN_USER_ATTRIBUTE_LIST_QUERY from "../_networking/internal-admin-user-attribute-list";
import { groupBy } from "lodash";

interface IProps {
  organizationId?: string;
  input: InternalAdminUserAttributeListInput;
}

const useInternalAdminUserAttributeList = ({
  organizationId,
  input,
}: IProps) => {
  const { data, loading, refetch } = useQuery<
    InternalAdminUserAttributeListQuery,
    InternalAdminUserAttributeListQueryVariables
  >(INTERNAL_ADMIN_USER_ATTRIBUTE_LIST_QUERY, {
    fetchPolicy: "network-only",
    variables: organizationId
      ? {
          organizationId,
          input,
        }
      : undefined,
    skip: !organizationId,
  });

  const userAttributes = useMemo(() => {
    if (!data) return [];
    return [...data.internalAdminUserAttributeList];
  }, [data]);

  const userAttributesByUserAttributeCategoryId = useMemo(
    () => groupBy(userAttributes, "userAttributeCategoryId"),
    [userAttributes],
  );

  return {
    userAttributes,
    userAttributesByUserAttributeCategoryId,
    loading,
    refetch,
  };
};

export default useInternalAdminUserAttributeList;
